<template>
  <div ref="modal">
    <div class="media-gallery__modal-bg" @click="close"></div>
    <div
      ref="modalBody"
      class="media-gallery__modal"
      :class="scheme == 'small' ? '-small' : ''"
    >
      <h4 class="media-gallery__modal-header d-flex justify-content-between">
        <span>Media Gallery</span>

        <button @click="close" class="media-gallery__modal-close">
          <img
            data-v-7b8cef96=""
            src="/img/close.032d61c0.svg"
            alt="close icon"
          />
        </button>
      </h4>
      <MediaGallery
        class="media-gallery__modal-content"
        @response="handleMedia"
        @close="close"
      />
    </div>
  </div>
</template>

<script>
import MediaGallery from "@/components/media-gallery/MediaGallery";
export default {
  components: {
    MediaGallery
  },
  props: {
    scheme: {
      type: String,
      default: "default"
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleMedia(obj) {
      this.$emit("response", obj);
    }
  },
  mounted() {
    this.$refs.modalBody.scrollIntoView();
  }
};
</script>
<style lang="scss" scoped>
.media-gallery {
  &__modal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1010;
    background: white;
    overflow: auto;
    padding: 40px;
    border-radius: 8px;
    &.-small {
      animation: fade-in-up 0.25s ease-out forwards;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 650px;
      max-height: 600px;
    }
    &-header {
      font-family: "Gotham", sans-serif;
      color: #232323;
      font-size: 1rem;
      margin-bottom: 40px;
      position: relative;
      font-weight: 400;
      span {
        font-family: "Gotham", sans-serif;
      }
    }
    &-close {
      border: none;
      background: transparent;
      cursor: pointer;
    }
    &-bg {
      background: #000;
      height: 100vh;
      width: 100vw;
      position: absolute;
      opacity: 0.3;
      top: 0;
      z-index: 1009;
      left: 0;
    }
    &-content {
      background: #fff;
      .form-control {
        font-size: $font-size-sm;
      }
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
